import Vue from 'vue'
import App from './App.vue'
import store from './store'
import VueAnalytics from 'vue-analytics'

Vue.config.productionTip = false

Vue.use(VueAnalytics, {
  id: 'UA-119697739-1',
  debug: {
    sendHitTask: process.env.NODE_ENV === 'production'
  },
  checkDuplicatedScript: true
})

// Where should I put this ??
import ScrollView from 'vue-scrollview'
Vue.use(ScrollView)

// globally register multiselect
import Multiselect from 'vue-multiselect'
Vue.component('multiselect', Multiselect)

// Import store
// import Vuex from 'vuex'
// Vue.use(Vuex)

new Vue({
  store,
  render: h => h(App)
}).$mount('#app')
